// extracted by mini-css-extract-plugin
export default {"TeamHeader":"TeamHeader_TeamHeader__Erevo"};